import { apiSlice } from '../../app/api/apiSlice';
import { UpdateUserInfoRequest } from '../../types/request';
import { CreateNewStaffResponse, GetAllUsersResponse, GetUserDetailsResponse } from '../../types/response';
import { CreateNewStaff, StaffData, UserDetails } from '../../types/user';

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllUsersStaff: builder.query<StaffData[], void>({
            query: () => '/api/staff',
            transformResponse: (response: GetAllUsersResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: [{ type: 'Staff', id: 'LIST' }],
        }),

        createNewStaff: builder.mutation<CreateNewStaffResponse, CreateNewStaff>({
            query: (newStaffForm) => ({
                    url: '/api/staff/register', 
                    method: 'POST',
                    body: newStaffForm, 
            }),
            invalidatesTags: [{ type: 'Staff', id: 'LIST' }],
        }),

        updateStaff: builder.mutation<CreateNewStaffResponse, { staffId: number, data: CreateNewStaff}>({
            query: ({staffId, data}) => ({
                url: `/api/staff/${staffId}`, 
                method: 'PUT',
                body: data, 
            }),
            invalidatesTags: (result, error, { staffId }) => [
                { type: 'Staff', id: 'LIST' },
                { type: 'Staff', id: staffId },
            ],
        }),

        getInfoByStaffId: builder.query<UserDetails, number>({
            query: (staffId) => `/api/staff/${staffId}`,
            transformResponse: (response: GetUserDetailsResponse) => response.data,
            transformErrorResponse: (response) => response.data,
            providesTags: (result, error, staffId) => [
                { type: 'Staff', id: staffId },
            ],
        }),
        
        updateMyAccountInfo: builder.mutation<any, UpdateUserInfoRequest>({
            query: (UpdateUserInfoRequest) => ({
                url: `/api/staff/info/${UpdateUserInfoRequest.staffID}`, 
                method: 'PUT',
                body: UpdateUserInfoRequest.info, 
            }),
            invalidatesTags: (result, error, { staffID }) => [
                { type: 'Staff', id: 'LIST' },
                { type: 'Staff', id: staffID },
            ],
        })
    }),
});

export const { 
    useGetAllUsersStaffQuery,
    useCreateNewStaffMutation,
    useUpdateStaffMutation,
    useGetInfoByStaffIdQuery,
    useUpdateMyAccountInfoMutation,
} = usersApiSlice;